// extracted by mini-css-extract-plugin
export default {"link":"Ingredient_link__HFNLv","span":"Ingredient_span__LHXXo","price":"Ingredient_price__CIEQs","name":"Ingredient_name__bUorL"};